import { createTheme, Theme } from "@mui/material/styles";

export const portalDashboardLargeButtonFont = {
  fontSize: "1.25rem",
  fontWeight: 600,
  lineHeight: 1.35,
} as const;

/**
 * Nested theme for `/portal/*`: senior-optimised typography, larger touch targets.
 * Merge with the root theme via ThemeProvider.
 */
export function createPortalTheme(baseTheme: Theme): Theme {
  return createTheme(baseTheme, {
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            "&.MuiButton-sizeLarge": {
              minHeight: 60,
              paddingLeft: baseTheme.spacing(3.5),
              paddingRight: baseTheme.spacing(3.5),
              ...portalDashboardLargeButtonFont,
            },
            "&.MuiButton-sizeMedium": {
              minHeight: 52,
              paddingLeft: baseTheme.spacing(3),
              paddingRight: baseTheme.spacing(3),
              fontSize: "1.0625rem",
            },
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            padding: 12,
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          // Tile titles
          h6: {
            fontSize: "1.625rem",
            fontWeight: 500,
          },
          // Sub-section headings
          h5: {
            fontSize: "1.75rem",
            fontWeight: 500,
          },
          // General body text — 18px for readability
          body1: {
            fontSize: "1.125rem",
          },
          body2: {
            fontSize: "1rem",
          },
          subtitle1: {
            fontSize: "1.125rem",
          },
          subtitle2: {
            fontSize: "1rem",
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            fontSize: "0.9375rem",
            height: 36,
            padding: "0 4px",
          },
        },
      },
    },
  });
}
